import { colors } from "./semanticColors";
import { spacing } from "../../../spacing";
export var publicCapioTheme = {
  colors: colors,
  spacing: spacing
};